// store/modules/ticketStore.js
import { 
  getRandomReduction,
  getTimeToNextHour,
  initCurrentTickets,
} from "@/utils/_ticketsData";

const state = {
  tickets: 3999, // 每小时门票数量
  hourTicketsArr: [], // 每小时门票数量数组
  bigRegisteredCount: 0, // 大基数报名人数 = 26000 + (3999 - 每小时门票数量)
  registeredCount: 0, // 有总量限制报名人数 = 30000 - 每小时门票数量
  reductionTimer: null,
  resetTimer: null
};

const getters = {
  getTickets: state => state.tickets,
  getHourTicketsArr: state => state.hourTicketsArr,
  getBigRegisteredCount: state => state.bigRegisteredCount,
  getRegisteredCount: state => state.registeredCount,
  getTicketData: state => ({
    tickets: state.tickets,
    bigRegisteredCount: state.bigRegisteredCount,
    registeredCount: state.registeredCount
  })
};

const mutations = {
  SET_TICKETS(state, tickets) {
    state.tickets = tickets;
    state.hourTicketsArr = tickets.toString().split('');
  },
  SET_BIG_REGISTERED_COUNT(state, count) {
    state.bigRegisteredCount = count;
  },
  SET_REGISTERED_COUNT(state, count) {
    state.registeredCount = count;
  },
  SET_REDUCTION_TIMER(state, timer) {
    state.reductionTimer = timer;
  },
  SET_RESET_TIMER(state, timer) {
    state.resetTimer = timer;
  },
  UPDATE_ALL_COUNTS(state) {
    state.bigRegisteredCount = 26000 + (3999 - state.tickets);
    state.registeredCount = 30000 - state.tickets;
  }
};

const actions = {
  // 开始减少门票
  startReduction({ commit, dispatch, state }) {
    // 清除现有定时器
    if (state.reductionTimer) {
      clearInterval(state.reductionTimer);
    }

    const reductionTimer = setInterval(() => {
      // 如果门票已经少于等于10张，停止减少
      if (state.tickets <= 10) {
        dispatch('stopReduction');
        commit('SET_TICKETS', 10);
        commit('UPDATE_ALL_COUNTS');
        return;
      }
      
      const reduction = getRandomReduction();
      const newTickets = Math.max(10, state.tickets - reduction);
      
      commit('SET_TICKETS', newTickets);
      commit('UPDATE_ALL_COUNTS');
      
    }, 2000);

    commit('SET_REDUCTION_TIMER', reductionTimer);
  },

  // 停止减少门票
  stopReduction({ commit, state }) {
    if (state.reductionTimer) {
      clearInterval(state.reductionTimer);
      commit('SET_REDUCTION_TIMER', null);
    }
  },

  // 重置门票数量到3999
  resetTickets({ commit, dispatch }) {
    console.log('整点重置门票到3999');
    commit('SET_TICKETS', 3999);
    commit('UPDATE_ALL_COUNTS');
    
    // 重新开始减少
    dispatch('stopReduction');
    dispatch('startReduction');
  },

  // 初始化当前门票数量
  initCurrentTickets({ commit }) {
    const currentTicketsData = initCurrentTickets();
    const tickets = Math.max(10, currentTicketsData.currentTickets);
    
    commit('SET_TICKETS', tickets);
    commit('UPDATE_ALL_COUNTS');
  },

  // 整点重置定时器
  setupResetTimer({ commit, dispatch }) {
    const timeToNextHour = getTimeToNextHour();
    
    // 清除现有定时器
    if (state.resetTimer) {
      clearTimeout(state.resetTimer);
    }

    const resetTimer = setTimeout(() => {
      dispatch('resetTickets');
      
      // 设置每小时重置一次
      const hourlyTimer = setInterval(() => {
        dispatch('resetTickets');
      }, 60 * 60 * 1000);
      
      commit('SET_RESET_TIMER', hourlyTimer);
      
    }, timeToNextHour);

    commit('SET_RESET_TIMER', resetTimer);
  },

  // 初始化所有定时器和数据
  initializeTicketSystem({ dispatch }) {
    console.log('初始化门票系统');
    dispatch('initCurrentTickets');
    
    // 只有在门票大于10时才启动减少定时器
    if (state.tickets > 10) {
      dispatch('startReduction');
    }
    
    dispatch('setupResetTimer');
  },

  // 清理所有定时器
  cleanupTimers({ commit, state }) {
    if (state.reductionTimer) {
      clearInterval(state.reductionTimer);
      commit('SET_REDUCTION_TIMER', null);
    }
    
    if (state.resetTimer) {
      if (typeof state.resetTimer == 'number') {
        clearTimeout(state.resetTimer);
      } else {
        clearInterval(state.resetTimer);
      }
      commit('SET_RESET_TIMER', null);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};